<template>
  <div class="personal">
    <Header></Header>
    <div class="content clear">
      <Navbar :userInfo="userInfo"></Navbar>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Header from "@/modules/headers.vue";
import Navbar from "@/modules/navbar.vue";
import {
  getUserMsg,
  pageCourseSchedule,
  pageStudent,
  exportStudent
} from "@/assets/js/axios.js";
export default {
  name: "personal",
  data() {
    return {
      userInfo: {},
      tableDatas: [],
      tableData: [],
      page: 1,
      row: 10,
      currentPage: 1,
      total: 0,
      loginStatus: this.cookieVue.getCookie("loginStatus"),
      student: false
    };
  },
  created() {
    getUserMsg().then(res => {
      this.userInfo = res.data;
    });
    // this._pageCourseSchedule();
  },
  methods: {
    toDetail(uid) {
      pageCourseSchedule(this.page, this.row, uid).then(res => {
        this.tableDatas = res.data;
        this.student = true;
      });
    },
    handleSizeChange(val) {
      this.row = val;
      this._pageCourseSchedule();
    },
    handleCurrentChange(val) {
      this.page = val;
      this._pageCourseSchedule();
    },
    _pageCourseSchedule() {
      if (this.loginStatus == 2) {
        pageCourseSchedule(this.page, this.row).then(res => {
          this.tableDatas = res.data;
        });
      } else {
        pageStudent(this.page, this.row).then(res => {
          this.tableData = res.data;
        });
      }
    },
    statusFun(row, column) {
      switch (row.applyStatus) {
        case 0:
          return "不够学分";
        case 1:
          return "可以申请";
        case 2:
          return "已申请未批";
        case 3:
          return "已通过未答";
        case 4:
          return "已答";
      }
    }
  },
  components: {
    Header,
    Navbar
  }
};
</script>

<style lang="less" scoped>
.personal {
  width: 100%;
  min-width: 1200px;
  min-height: 100vh;
  .content {
    width: 1200px;
    min-height: 700px;
    margin: 2px auto;
    background: rgb(248, 248, 248);
    padding: 40px 0;

    .rightContent {
      float: left;
      margin-left: 15px;
      width: 1010px;
      /deep/ .title {
        background: #fff;
        height: 46px;
        widows: 984px;
        line-height: 46px;
        padding-left: 26px;
        font-size: 14px;
        color: rgb(102, 102, 102);
        margin-bottom: 12px;
        span {
          color: #1b1f34;
          font-size: 18px;
          padding-right: 26px;
        }
        button,.button {
          font-size: 14px;
          line-height: 22px;
          z-index: 124;
          background: #109eff;
          border: none;
          outline: none;
          color: #fff;
          width: 80px;
          height: 22px;
          border-radius: 4px;
          float: right;
          margin-right: 10px;
          margin-top: 12px;
          cursor: pointer;
          text-align: center;
        }
      }
      /deep/ .table {
        background: #fff;
        width: 1010px;
        overflow: hidden;
        .exportStudent {
          float: right;
          background: #109eff;
          width: 80px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          color: #fff;
          cursor: pointer;
          border-radius: 4px;
          font-size: 14px;
          border: none;
          outline: none;
          margin-right: 40px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        /deep/ .el-table {
          margin: 10px;
          font-size: 14px;
          text-align: center;
          a {
            color: #109eff;
          }
        }
        /deep/ .el-pagination {
          margin: 18px 0;
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personal/index.vue